import { isNullOrEmptyArray } from 'src/util/arrays';

/**
 * util: Recupera os itens que fazem parte de uma consolidação
 */
export function getConsolidatedItems(initialData, consolidations) {
  const consolidatedAltsIds = !isNullOrEmptyArray(consolidations)
    ? consolidations
        .map((cons) => cons.alternatives.map((con) => con.value))
        .reduce((prev, curr) => [...prev, ...curr])
    : [];

  return initialData.filter((item) => consolidatedAltsIds.includes(item.value));
}

/**
 * Transforma o array de id's das alternativas em uma string de id's em ordem crescente
 * @param {Array<number>} ids
 * @returns string
 */
export const transformIds = (ids) => ids.sort((a, b) => a - b).toString();

/**
 * Converte uma consolidação em um objeto com os ids de suas alternativas consolidadas.
 * @param {object} cons Objeto de consolidação
 * @returns {number[]}
 */
export const consolidationToAltsIds = (cons) =>
  cons.alternatives.map((alt) => alt.value);

/**
 * Transforma todas as consolidações em um array com todos os id's das alternativas consolidadas.
 * @param {Array<object>} cons Array com todas as consolidações
 * @returns {number[]}
 */
export const allConsolidationsToAltsIds = (cons) =>
  (cons &&
    !!cons.length &&
    cons
      .map((c) => consolidationToAltsIds(c))
      .reduce((prev, curr) => [...prev, ...curr], [])) ||
  [];

/**
 * util: Converte as configurações da pergunta atual que vieram do servidor (representado por data)
 * no modelo de consolidação
 */
export const dataToConsolidationSchema = (data) => {
  const altsFromQuestion = data;
  const consolidationsFromAlts = altsFromQuestion
    .filter((alt) => !isNullOrEmptyArray(alt.alternativas_consolidadas))
    .map((alt) =>
      getConsolidationSchema({
        value: alt.id,
        alternatives: alt.alternativas_consolidadas.map(
          ({ id: value, enunciado: title, resultado_percentual }) => ({ value, title, resultado_percentual })
        ),
        title: alt.enunciado,
        editMode: false,
      })
    );

  return consolidationsFromAlts;
};

/**
 * Util: Retorna o objeto de consolidação com base nas alternativas
 */
export const getConsolidationSchema = ({
  value,
  alternatives,
  title,
  editMode,
}) => ({
  // value -> ID da alternativa, se a consolidação não possuir id significa que ela é uma nova consolidação
  ...(value ? { value } : {}),
  alternatives,
  title,
  editMode,
});
